import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InlineSVG = _resolveComponent("InlineSVG")

  return (_openBlock(), _createBlock(_component_InlineSVG, {
    width: _ctx.width,
    height: _ctx.height,
    src: _ctx.src,
    "aria-label": _ctx.ariaLabel,
    transformSource: _ctx.transform
  }, null, 8, ["width", "height", "src", "aria-label", "transformSource"]))
}